import { LEVELS, PLAYABLE_LEVELS, clampLevel } from './chart';

export interface KeyValueStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export const UNLOCK_KEY = 'solta.nivel.liberado';

export function boardSeed(seed: string, level: number | string): string {
  return typeof level === 'number' ? `${seed}:n${level}` : `${seed}:${level}`;
}

export function unlockedLevel(store: KeyValueStore | null): number {
  if (store === null) return 1;
  let raw: string | null = null;
  try {
    raw = store.getItem(UNLOCK_KEY);
  } catch {
    return 1;
  }
  const value = raw === null ? 1 : Number.parseInt(raw, 10);
  return Number.isFinite(value) ? clampLevel(value) : 1;
}

export function clearLevel(store: KeyValueStore | null, level: number): number {
  const next = Math.min(PLAYABLE_LEVELS, Math.max(unlockedLevel(store), level + 1));
  if (store === null) return next;
  try {
    store.setItem(UNLOCK_KEY, String(next));
  } catch {
    return next;
  }
  return next;
}

export function forcedLevel(search: string): number | null {
  const raw = new URLSearchParams(search).get('nivel');
  if (raw === null || raw.trim() === '') return null;
  return clampLevel(Number(raw));
}

export interface LevelEntry {
  readonly level: number;
  readonly name: string;
  readonly playable: boolean;
  readonly unlocked: boolean;
}

export function levelList(unlocked: number): readonly LevelEntry[] {
  return LEVELS.map((spec) => ({
    level: spec.level,
    name: spec.name,
    playable: spec.level <= PLAYABLE_LEVELS,
    unlocked: spec.level <= PLAYABLE_LEVELS && spec.level <= unlocked,
  }));
}
